import { doc, updateDoc } from 'firebase/firestore';
import React,  { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
//@ts-ignore
import {db} from '../../utils/firebase.js'

const AddPayment = () => {
  const [formData, setFormData] = useState({
    email: '',
    lastPaymentDate: '',
    lastPaymentAmount: '',
    nextPaymentDate: '',
    nextPaymentAmount: '',
  });

  const handleChange = (e : React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    if (
      !formData.email ||
      !formData.lastPaymentDate ||
      !formData.lastPaymentAmount ||
      !formData.nextPaymentDate ||
      !formData.nextPaymentAmount
    ) {
      toast.error("Please fill in all required fields.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  }

  const handleSubmit = async (e : React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log("Updating Payment Details:", formData);

    if(validate()){
      try {
        const userDocRef = doc(db, "userDetails", formData.email);
    
        await updateDoc(userDocRef, {
          lastPaymentDate: formData.lastPaymentDate,
          lastPaymentAmount: formData.lastPaymentAmount,
          nextPaymentDate: formData.nextPaymentDate,
          nextPaymentAmount: formData.nextPaymentAmount,
        });
    
        toast.success("Payment details updated successfully!");
    
        setFormData({
          email: "",
          lastPaymentDate: "",
          lastPaymentAmount: "",
          nextPaymentDate: "",
          nextPaymentAmount: "",
        });
    
      } catch (error: any) {
        console.error("Error updating payment details:");
        toast.error("The email is not registered with our business, please register user first");
        setFormData({
          email: "",
          lastPaymentDate: "",
          lastPaymentAmount: "",
          nextPaymentDate: "",
          nextPaymentAmount: "",
        });
      }
    }
   
  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <h2 className="text-xl font-bold mb-6">Add Payment Details</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Email ID */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email ID</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Last Payment Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Last Payment Date</label>
          <input
            type="date"
            name="lastPaymentDate"
            value={formData.lastPaymentDate}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Last Payment Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Last Payment Amount</label>
          <input
            type="number"
            name="lastPaymentAmount"
            value={formData.lastPaymentAmount}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Next Payment Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Next Payment Date</label>
          <input
            type="date"
            name="nextPaymentDate"
            value={formData.nextPaymentDate}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Next Payment Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Next Payment Amount</label>
          <input
            type="number"
            name="nextPaymentAmount"
            value={formData.nextPaymentAmount}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Add Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Add Payment
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPayment;